import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const statusIndicatorVariants = cva('rounded-full flex-shrink-0', {
  variants: {
    status: {
      pass: 'bg-success',
      warn: 'bg-warning',
      fail: 'bg-danger',
      unknown: 'bg-muted',
    },
    size: {
      sm: 'w-3 h-3',
      md: 'w-4 h-4',
      lg: 'w-5 h-5',
    },
  },
  defaultVariants: {
    status: 'unknown',
    size: 'md',
  },
});

export interface StatusIndicatorProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof statusIndicatorVariants> {
  label?: string;
}

/**
 * StatusIndicator - Visual indicator for health check status
 */
export function StatusIndicator({
  status,
  size,
  label,
  className,
  ...props
}: StatusIndicatorProps) {
  return (
    <div
      className={cn(statusIndicatorVariants({ status, size }), className)}
      title={label}
      aria-label={label}
      role="status"
      {...props}
    />
  );
}
